function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 89,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 89,
  width: 89,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 178,
  width: 89,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 267,
  width: 89,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M89 0V145",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M178 0V145",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M267 0V145",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.104 78H26.196V71.484H25.104V78ZM25.656 70.14C26.088 70.14 26.388 69.852 26.388 69.408C26.388 68.988 26.088 68.7 25.656 68.7C25.224 68.7 24.924 68.988 24.924 69.408C24.924 69.852 25.224 70.14 25.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4087 78H29.5007V73.272C30.1007 72.6 30.6527 72.276 31.1447 72.276C31.9727 72.276 32.3567 72.792 32.3567 74.016V78H33.4487V73.272C34.0607 72.6 34.5887 72.276 35.0927 72.276C35.9207 72.276 36.3047 72.792 36.3047 74.016V78H37.3967V73.872C37.3967 72.204 36.7607 71.316 35.4167 71.316C34.6247 71.316 33.9407 71.832 33.2687 72.564C33.0047 71.796 32.4647 71.316 31.4687 71.316C30.6887 71.316 30.0047 71.808 29.4407 72.432H29.4047L29.3087 71.484H28.4087V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M41.0181 78.156C41.8221 78.156 42.5541 77.736 43.1781 77.22H43.2141L43.3101 78H44.2101V73.992C44.2101 72.384 43.5381 71.316 41.9541 71.316C40.9101 71.316 39.9861 71.784 39.3861 72.168L39.8181 72.924C40.3341 72.576 41.0181 72.228 41.7741 72.228C42.8421 72.228 43.1181 73.032 43.1181 73.872C40.3461 74.184 39.1101 74.892 39.1101 76.308C39.1101 77.484 39.9261 78.156 41.0181 78.156ZM41.3301 77.28C40.6821 77.28 40.1781 76.98 40.1781 76.236C40.1781 75.396 40.9221 74.856 43.1181 74.592V76.416C42.4821 76.98 41.9661 77.28 41.3301 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4875 81C50.5035 81 51.7875 79.956 51.7875 78.744C51.7875 77.676 51.0195 77.196 49.5075 77.196H48.2355C47.3595 77.196 47.0955 76.908 47.0955 76.488C47.0955 76.128 47.2755 75.912 47.5155 75.708C47.8035 75.852 48.1635 75.936 48.4875 75.936C49.8075 75.936 50.8635 75.06 50.8635 73.668C50.8635 73.104 50.6475 72.624 50.3355 72.324H51.6675V71.484H49.3995C49.1715 71.4 48.8475 71.316 48.4875 71.316C47.1675 71.316 46.0395 72.216 46.0395 73.644C46.0395 74.424 46.4595 75.048 46.8915 75.396V75.444C46.5555 75.684 46.1595 76.116 46.1595 76.656C46.1595 77.172 46.4115 77.52 46.7595 77.724V77.772C46.1475 78.168 45.7995 78.696 45.7995 79.248C45.7995 80.376 46.8915 81 48.4875 81ZM48.4875 75.192C47.7315 75.192 47.0955 74.592 47.0955 73.644C47.0955 72.684 47.7195 72.12 48.4875 72.12C49.2555 72.12 49.8795 72.696 49.8795 73.644C49.8795 74.592 49.2315 75.192 48.4875 75.192ZM48.6435 80.256C47.4675 80.256 46.7595 79.8 46.7595 79.104C46.7595 78.72 46.9515 78.336 47.4195 78C47.7075 78.072 48.0195 78.108 48.2595 78.108H49.3875C50.2515 78.108 50.7195 78.312 50.7195 78.912C50.7195 79.596 49.8915 80.256 48.6435 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M55.5054 78.156C56.3934 78.156 57.0895 77.856 57.6655 77.484L57.2695 76.764C56.7895 77.088 56.2734 77.28 55.6374 77.28C54.4014 77.28 53.5494 76.392 53.4774 75H57.8694C57.8935 74.844 57.9174 74.616 57.9174 74.376C57.9174 72.516 56.9814 71.316 55.3254 71.316C53.8134 71.316 52.3854 72.636 52.3854 74.748C52.3854 76.896 53.7774 78.156 55.5054 78.156ZM53.4654 74.208C53.5974 72.936 54.4134 72.192 55.3375 72.192C56.3575 72.192 56.9575 72.9 56.9575 74.208H53.4654Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M59.474 78H64.298V77.088H62.534V69.444H61.694C61.214 69.732 60.65 69.936 59.87 70.068V70.776H61.43V77.088H59.474V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M114.104 78H115.196V71.484H114.104V78ZM114.656 70.14C115.088 70.14 115.388 69.852 115.388 69.408C115.388 68.988 115.088 68.7 114.656 68.7C114.224 68.7 113.924 68.988 113.924 69.408C113.924 69.852 114.224 70.14 114.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M117.409 78H118.501V73.272C119.101 72.6 119.653 72.276 120.145 72.276C120.973 72.276 121.357 72.792 121.357 74.016V78H122.449V73.272C123.061 72.6 123.589 72.276 124.093 72.276C124.921 72.276 125.305 72.792 125.305 74.016V78H126.397V73.872C126.397 72.204 125.761 71.316 124.417 71.316C123.625 71.316 122.941 71.832 122.269 72.564C122.005 71.796 121.465 71.316 120.469 71.316C119.689 71.316 119.005 71.808 118.441 72.432H118.405L118.309 71.484H117.409V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M130.018 78.156C130.822 78.156 131.554 77.736 132.178 77.22H132.214L132.31 78H133.21V73.992C133.21 72.384 132.538 71.316 130.954 71.316C129.91 71.316 128.986 71.784 128.386 72.168L128.818 72.924C129.334 72.576 130.018 72.228 130.774 72.228C131.842 72.228 132.118 73.032 132.118 73.872C129.346 74.184 128.11 74.892 128.11 76.308C128.11 77.484 128.926 78.156 130.018 78.156ZM130.33 77.28C129.682 77.28 129.178 76.98 129.178 76.236C129.178 75.396 129.922 74.856 132.118 74.592V76.416C131.482 76.98 130.966 77.28 130.33 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M137.487 81C139.503 81 140.787 79.956 140.787 78.744C140.787 77.676 140.019 77.196 138.507 77.196H137.235C136.359 77.196 136.095 76.908 136.095 76.488C136.095 76.128 136.275 75.912 136.515 75.708C136.803 75.852 137.163 75.936 137.487 75.936C138.807 75.936 139.863 75.06 139.863 73.668C139.863 73.104 139.647 72.624 139.335 72.324H140.667V71.484H138.399C138.171 71.4 137.847 71.316 137.487 71.316C136.167 71.316 135.039 72.216 135.039 73.644C135.039 74.424 135.459 75.048 135.891 75.396V75.444C135.555 75.684 135.159 76.116 135.159 76.656C135.159 77.172 135.411 77.52 135.759 77.724V77.772C135.147 78.168 134.799 78.696 134.799 79.248C134.799 80.376 135.891 81 137.487 81ZM137.487 75.192C136.731 75.192 136.095 74.592 136.095 73.644C136.095 72.684 136.719 72.12 137.487 72.12C138.255 72.12 138.879 72.696 138.879 73.644C138.879 74.592 138.231 75.192 137.487 75.192ZM137.643 80.256C136.467 80.256 135.759 79.8 135.759 79.104C135.759 78.72 135.951 78.336 136.419 78C136.707 78.072 137.019 78.108 137.259 78.108H138.387C139.251 78.108 139.719 78.312 139.719 78.912C139.719 79.596 138.891 80.256 137.643 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M144.505 78.156C145.393 78.156 146.089 77.856 146.665 77.484L146.269 76.764C145.789 77.088 145.273 77.28 144.637 77.28C143.401 77.28 142.549 76.392 142.477 75H146.869C146.893 74.844 146.917 74.616 146.917 74.376C146.917 72.516 145.981 71.316 144.325 71.316C142.813 71.316 141.385 72.636 141.385 74.748C141.385 76.896 142.777 78.156 144.505 78.156ZM142.465 74.208C142.597 72.936 143.413 72.192 144.337 72.192C145.357 72.192 145.957 72.9 145.957 74.208H142.465Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M147.946 78H153.478V77.052H150.994C150.538 77.052 150.01 77.1 149.554 77.136C151.582 75 153.046 73.404 153.046 71.796C153.046 70.284 152.062 69.288 150.49 69.288C149.374 69.288 148.618 69.804 147.898 70.584L148.534 71.196C149.014 70.632 149.638 70.176 150.358 70.176C151.45 70.176 151.978 70.872 151.978 71.844C151.978 73.248 150.526 74.784 147.946 77.352V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M203.104 80H204.196V73.484H203.104V80ZM203.656 72.14C204.088 72.14 204.388 71.852 204.388 71.408C204.388 70.988 204.088 70.7 203.656 70.7C203.224 70.7 202.924 70.988 202.924 71.408C202.924 71.852 203.224 72.14 203.656 72.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M206.409 80H207.501V75.272C208.101 74.6 208.653 74.276 209.145 74.276C209.973 74.276 210.357 74.792 210.357 76.016V80H211.449V75.272C212.061 74.6 212.589 74.276 213.093 74.276C213.921 74.276 214.305 74.792 214.305 76.016V80H215.397V75.872C215.397 74.204 214.761 73.316 213.417 73.316C212.625 73.316 211.941 73.832 211.269 74.564C211.005 73.796 210.465 73.316 209.469 73.316C208.689 73.316 208.005 73.808 207.441 74.432H207.405L207.309 73.484H206.409V80Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M219.018 80.156C219.822 80.156 220.554 79.736 221.178 79.22H221.214L221.31 80H222.21V75.992C222.21 74.384 221.538 73.316 219.954 73.316C218.91 73.316 217.986 73.784 217.386 74.168L217.818 74.924C218.334 74.576 219.018 74.228 219.774 74.228C220.842 74.228 221.118 75.032 221.118 75.872C218.346 76.184 217.11 76.892 217.11 78.308C217.11 79.484 217.926 80.156 219.018 80.156ZM219.33 79.28C218.682 79.28 218.178 78.98 218.178 78.236C218.178 77.396 218.922 76.856 221.118 76.592V78.416C220.482 78.98 219.966 79.28 219.33 79.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M226.487 83C228.503 83 229.787 81.956 229.787 80.744C229.787 79.676 229.019 79.196 227.507 79.196H226.235C225.359 79.196 225.095 78.908 225.095 78.488C225.095 78.128 225.275 77.912 225.515 77.708C225.803 77.852 226.163 77.936 226.487 77.936C227.807 77.936 228.863 77.06 228.863 75.668C228.863 75.104 228.647 74.624 228.335 74.324H229.667V73.484H227.399C227.171 73.4 226.847 73.316 226.487 73.316C225.167 73.316 224.039 74.216 224.039 75.644C224.039 76.424 224.459 77.048 224.891 77.396V77.444C224.555 77.684 224.159 78.116 224.159 78.656C224.159 79.172 224.411 79.52 224.759 79.724V79.772C224.147 80.168 223.799 80.696 223.799 81.248C223.799 82.376 224.891 83 226.487 83ZM226.487 77.192C225.731 77.192 225.095 76.592 225.095 75.644C225.095 74.684 225.719 74.12 226.487 74.12C227.255 74.12 227.879 74.696 227.879 75.644C227.879 76.592 227.231 77.192 226.487 77.192ZM226.643 82.256C225.467 82.256 224.759 81.8 224.759 81.104C224.759 80.72 224.951 80.336 225.419 80C225.707 80.072 226.019 80.108 226.259 80.108H227.387C228.251 80.108 228.719 80.312 228.719 80.912C228.719 81.596 227.891 82.256 226.643 82.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M233.505 80.156C234.393 80.156 235.089 79.856 235.665 79.484L235.269 78.764C234.789 79.088 234.273 79.28 233.637 79.28C232.401 79.28 231.549 78.392 231.477 77H235.869C235.893 76.844 235.917 76.616 235.917 76.376C235.917 74.516 234.981 73.316 233.325 73.316C231.813 73.316 230.385 74.636 230.385 76.748C230.385 78.896 231.777 80.156 233.505 80.156ZM231.465 76.208C231.597 74.936 232.413 74.192 233.337 74.192C234.357 74.192 234.957 74.9 234.957 76.208H231.465Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M239.586 80.156C241.146 80.156 242.406 79.244 242.406 77.72C242.406 76.544 241.578 75.788 240.546 75.536V75.488C241.47 75.152 242.106 74.492 242.106 73.46C242.106 72.068 241.026 71.288 239.55 71.288C238.53 71.288 237.75 71.732 237.09 72.356L237.678 73.04C238.17 72.536 238.794 72.176 239.502 72.176C240.414 72.176 240.99 72.704 240.99 73.532C240.99 74.432 240.366 75.14 238.554 75.14V75.98C240.582 75.98 241.29 76.652 241.29 77.672C241.29 78.632 240.546 79.244 239.502 79.244C238.506 79.244 237.834 78.776 237.318 78.236L236.766 78.956C237.342 79.58 238.206 80.156 239.586 80.156Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M292.104 80H293.196V73.484H292.104V80ZM292.656 72.14C293.088 72.14 293.388 71.852 293.388 71.408C293.388 70.988 293.088 70.7 292.656 70.7C292.224 70.7 291.924 70.988 291.924 71.408C291.924 71.852 292.224 72.14 292.656 72.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M295.409 80H296.501V75.272C297.101 74.6 297.653 74.276 298.145 74.276C298.973 74.276 299.357 74.792 299.357 76.016V80H300.449V75.272C301.061 74.6 301.589 74.276 302.093 74.276C302.921 74.276 303.305 74.792 303.305 76.016V80H304.397V75.872C304.397 74.204 303.761 73.316 302.417 73.316C301.625 73.316 300.941 73.832 300.269 74.564C300.005 73.796 299.465 73.316 298.469 73.316C297.689 73.316 297.005 73.808 296.441 74.432H296.405L296.309 73.484H295.409V80Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M308.018 80.156C308.822 80.156 309.554 79.736 310.178 79.22H310.214L310.31 80H311.21V75.992C311.21 74.384 310.538 73.316 308.954 73.316C307.91 73.316 306.986 73.784 306.386 74.168L306.818 74.924C307.334 74.576 308.018 74.228 308.774 74.228C309.842 74.228 310.118 75.032 310.118 75.872C307.346 76.184 306.11 76.892 306.11 78.308C306.11 79.484 306.926 80.156 308.018 80.156ZM308.33 79.28C307.682 79.28 307.178 78.98 307.178 78.236C307.178 77.396 307.922 76.856 310.118 76.592V78.416C309.482 78.98 308.966 79.28 308.33 79.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M315.488 83C317.504 83 318.788 81.956 318.788 80.744C318.788 79.676 318.02 79.196 316.508 79.196H315.236C314.36 79.196 314.096 78.908 314.096 78.488C314.096 78.128 314.276 77.912 314.516 77.708C314.804 77.852 315.164 77.936 315.488 77.936C316.808 77.936 317.864 77.06 317.864 75.668C317.864 75.104 317.648 74.624 317.336 74.324H318.668V73.484H316.4C316.172 73.4 315.848 73.316 315.488 73.316C314.168 73.316 313.04 74.216 313.04 75.644C313.04 76.424 313.46 77.048 313.892 77.396V77.444C313.556 77.684 313.16 78.116 313.16 78.656C313.16 79.172 313.412 79.52 313.76 79.724V79.772C313.148 80.168 312.8 80.696 312.8 81.248C312.8 82.376 313.892 83 315.488 83ZM315.488 77.192C314.732 77.192 314.096 76.592 314.096 75.644C314.096 74.684 314.72 74.12 315.488 74.12C316.256 74.12 316.88 74.696 316.88 75.644C316.88 76.592 316.232 77.192 315.488 77.192ZM315.644 82.256C314.468 82.256 313.76 81.8 313.76 81.104C313.76 80.72 313.952 80.336 314.42 80C314.708 80.072 315.02 80.108 315.26 80.108H316.388C317.252 80.108 317.72 80.312 317.72 80.912C317.72 81.596 316.892 82.256 315.644 82.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M322.506 80.156C323.394 80.156 324.09 79.856 324.666 79.484L324.27 78.764C323.79 79.088 323.274 79.28 322.638 79.28C321.402 79.28 320.55 78.392 320.478 77H324.87C324.894 76.844 324.918 76.616 324.918 76.376C324.918 74.516 323.982 73.316 322.326 73.316C320.814 73.316 319.386 74.636 319.386 76.748C319.386 78.896 320.778 80.156 322.506 80.156ZM320.466 76.208C320.598 74.936 321.414 74.192 322.338 74.192C323.358 74.192 323.958 74.9 323.958 76.208H320.466Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M326.798 76.76L328.802 73.82C329.054 73.4 329.294 73.028 329.51 72.62H329.558C329.534 73.076 329.498 73.808 329.498 74.252V76.76H326.798ZM329.498 80H330.53V77.636H331.694V76.76H330.53V71.444H329.318L325.658 76.916V77.636H329.498V80Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var Svg4BannersGrey = function Svg4BannersGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 145,
    viewBox: "0 0 356 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4BannersGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4banners_grey.9776f3f7.svg";
export { ForwardRef as ReactComponent };